import BookSeriesType from "types/BookSeriesType";
import BookGroup from "components/BookGroup";
import { BookGroupSizeType } from "components/BookGroup/types";
import BookGroupSeriesItem from "components/BookGroup/items/BookGroupSeriesItem";
import { isInPast } from "lib/dateUtils";
import SeriesHeader from "../headers/SeriesHeader";
import { BookSerializersBookByline, SeriesSerializersSeriesGroup } from "types/serializers";

export default function SeriesGroup({
  series,
  size,
  header = SeriesHeader
}: {
  series: SeriesSerializersSeriesGroup;
  size: BookGroupSizeType;
  header?: any
}) {
  const books: BookSerializersBookByline[] = series.bookSeries.map((bs) => {
    const seriesForBook = {
      id: bs.id,
      position: bs.position,
      details: bs.details,
    } as BookSeriesType;

    return {
      ...{ bookSeries: [seriesForBook] },
      ...bs.book,
    } as BookSerializersBookByline;
  })
  .filter((book) => isInPast(book.releaseDate));

  return (
    <BookGroup
      size={size}
      books={size === "lg" ? books : books.slice(0, 5)}
      HeaderComponent={header}
      ItemComponent={BookGroupSeriesItem}
      context={{ series }}
    />
  );
}
